import { styled } from '@mui/system';
import { ReactComponent as CompanyLogo } from '@assets/logo_icon.svg';


export const StyledCompanyLogo = styled(CompanyLogo)(({ theme }) => ({
    height: "100px"
}));
